import { render, staticRenderFns } from "./GifMenu.vue?vue&type=template&id=5be0ffde&"
import script from "./GifMenu.vue?vue&type=script&lang=js&"
export * from "./GifMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports